import { Component, OnInit, AfterViewChecked, ElementRef, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { Employer } from '../../models/employer';
import { IncomeInfo } from '../../models/incomeinfo';
import { AdditionalIncome } from '../../models/additionalincome';
import { Industry } from '../../models/industry';
import { LabelValue } from '../../models/labelvalue';
import { EmploymentStatus } from '../../models/employmentstatus';
import { EmployerDataService } from '../../../services/employer.service';
import { ApplicationDataService } from '../../../services/application.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Property } from '../../models/property';
import { EventEmitterService } from 'services/event-emitter.service';
import { SplashService } from 'services/splash.service';
import { TelephoneNumber } from 'app/models/telephone-number';
import { TwoYearsEmpDialogComponent } from './two-years-emp-dialog/two-years-emp-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ErrorService } from '../../../services/error.service';
import { ApplicationInterface } from 'app/interface/application';
import { AnalyticsService } from 'services/analytics.service';

@Component({
  selector: 'app-employment',
  templateUrl: './employment.component.html',
  styleUrls: ['./employment.component.css']
})
export class EmploymentComponent implements OnInit, AfterViewChecked {
  @ViewChild('employerTabs') employerTabs: MatTabGroup;
  @ViewChild('employmentInfo', { static: true }) private myScrollContainer: ElementRef;

  RentalApplicantKey: number;
  RentalApplicationKey: number;

  currentEmployer: Employer = null;
  previousEmployers: Employer[] = null;
  employmentStatus: LabelValue[];
  additionalIncome: AdditionalIncome = null;
  minDate = new Date(1910, 0, 1);
  minYear = this.minDate.getFullYear();
  disableSubmitBtn: Boolean = false;

  errorMessage: string;
  industries: LabelValue[];
  displayValidationMsg = false;
  autoCompleteSettings: any = {
    showSearchButton: false,
    showRecentSearch: false,
    geoTypes: ['establishment'],
    geoCountryRestriction: ['us'],
    inputPlaceholderText: 'Employer Name'
  };
  AddAdditionalApplicantKey: number = null;
  AddAdditionalApplicantName: string = null;
  ProofOfIncome: Document = null;
  CompletedByOther: boolean = false;
  modelProperty: Property;
  isCaVoucherEligible:boolean;
  caVoucherAmount:number=null;
  showCaRentVoucherTab:boolean=false;
  splashHTML: string;
  hasRentableItems: boolean;
  totalApplicationSteps: number = 8;
  navigateToVerifast: boolean;
  
  constructor(
    private employmentService: EmployerDataService,
    private applicationService: ApplicationDataService,
    public router: Router,
    public route: ActivatedRoute,
    private eventEmitterService: EventEmitterService,
    private splashService: SplashService,
    public dialog: MatDialog,
    private errorService: ErrorService,
    private readonly analyticsService: AnalyticsService) {
      this.analyticsService.track(
        'HRA Application',
        'Employment Information',
        'Start',
        'Start',
        '',
        this.additionalAnalyticsDetails());
    this.industries = [];
    const RentalApplicationKey = localStorage.getItem('RentalApplicationKey');
    const RentalApplicantKey = localStorage.getItem('RentalApplicantKey');
    const AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');
    const AddAdditionalApplicantName = localStorage.getItem('AddAdditionalApplicantName');
    const correctStatus = localStorage.getItem('CorrectStatus');

    if (correctStatus != "true") {
      localStorage.removeItem('RentalApplicationKey');
      this.analyticsService.track(
        'HRA Application',
        'Employment Information',
        'Stop',
        'Application not in the correct status',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/dashboard']);
    }

    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.AddAdditionalApplicantKey = Number(AddAdditionalApplicantKey);
    }

    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.AddAdditionalApplicantName = AddAdditionalApplicantName
    }

    this.eventEmitterService.splashChangeEmitted$.subscribe(res => this.updateSplashHTML(res));
    this.splashService.updateSplash("apply");
    if (RentalApplicantKey !== undefined && RentalApplicantKey !== null && RentalApplicationKey !== undefined && RentalApplicationKey !== null) {

      this.RentalApplicationKey = Number(RentalApplicationKey);

      if (this.AddAdditionalApplicantKey == null) {
        this.RentalApplicantKey = Number(RentalApplicantKey);
      }
      else {
        this.RentalApplicantKey = this.AddAdditionalApplicantKey;
      }
      const yardiKey = localStorage.getItem('YardiKey');
      this.employmentService.getEmploymentInformation(RentalApplicationKey, RentalApplicantKey, AddAdditionalApplicantKey, yardiKey)
        .subscribe(res => {
          this.onGetEmploymentSuccess(res)
        }, error => {
          this.errorMessage = this.applicationService.handleError(error)
        });
    } else {
      this.analyticsService.track(
        'HRA Application',
        'Employment Information',
        'Stop',
        'Application or applicant not in the right state',
        '/application/basic',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/basic']);
    }
  }

  private additionalAnalyticsDetails(): any {
    try {
      return {
        'CurrentEmployment': this.currentEmployer == null
          ? {}
          : {
            'Status': this.currentEmployer.EmploymentStatus,
            'Income': this.currentEmployer.MonthlyPay,
            'Industry': this.industries[this.currentEmployer.RentalIndustryKey],
            'Occupation': this.currentEmployer.Occupation
          },
        'PreviousEmployments': this.previousEmployers
            ?.map(x => {
              return {
                'Status': x.EmploymentStatus,
                'Income': x.MonthlyPay,
                'Industry': this.industries[x.RentalIndustryKey],
                'Occupation': x.Occupation
              };
            }) ?? [],
        'AdditionalIncomeAmount': this.additionalIncome?.AdditionalIncomeAmount,
        'AdditionalIncomeSource': this.additionalIncome?.AdditionalIncomeSource
      };
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  ngOnInit() {
    const rentableItems = localStorage.getItem('hasRentableItems');
    const verifastEnabled = localStorage.getItem('verifastEnabled');
    const hasAncillaryItems = localStorage.getItem('HasAncillaryItems');
    if ((rentableItems && rentableItems === 'true') || (hasAncillaryItems && hasAncillaryItems === 'true')) {
      this.hasRentableItems = true;
      this.totalApplicationSteps = 9;
    }
    
    if (verifastEnabled && verifastEnabled === 'true') {
      this.totalApplicationSteps++;
    }

    this.applicationService.getRentalIndustries()
      .subscribe(res => this.onGetIndustriesSuccess(res), err => this.applicationService.handleError(err));

    this.applicationService.getEmploymentStatuses().subscribe(res => this.getEmploymentStatus(res),
      res => this.applicationService.handleError(res))

    const property = JSON.parse(localStorage.getItem('SelectedProperty'));
    if (property != null) {
        this.modelProperty = property[0];
        if((property[0].min_rent != null && property[0].max_rent != null) && (property[0].min_rent == property[0].max_rent)){
          this.modelProperty.rent = property[0].min_rent.toLocaleString();
        }
        else if (property[0].min_rent != null && property[0].max_rent != null) {
          this.modelProperty.rent = property[0].min_rent.toLocaleString() + '-$'+ property[0].max_rent.toLocaleString()
        }
        var index=this.modelProperty.region.indexOf(',');
        this.isCaVoucherEligible= this.modelProperty.region.substring( index +1).trim()==='CA';
    }
  }

  ngAfterViewChecked() {

  }

  initializeCurrentEmployer = () => {
    if (!this.currentEmployer) {
      const newEmployer = new Employer();
      newEmployer.IsCurrnet = true;

      this.currentEmployer = newEmployer;
    }

    this.setSelectedIndex(0);
  }

  initializePreviousEmployers = () => {
    if (!this.previousEmployers || !this.previousEmployers.length) {
      this.previousEmployers = [new Employer()];
    }

    if (this.currentEmployer) {
      this.setSelectedIndex(1);
    } else {
      this.setSelectedIndex(0);
    }
  }

  addAdditionalPreviousEmployer = () => {
    if (!this.previousEmployers) {
      this.previousEmployers = [new Employer()]

      return;
    }

    this.previousEmployers.push(new Employer());
  }
  displayCaRentVoucher=()=>{
    return  this.isCaVoucherEligible && !this.showCaRentVoucherTab;
  }

  editCaRentVoucher=()=>{
    return  this.isCaVoucherEligible && this.showCaRentVoucherTab;
  }
  initializeCaRentVoucher = ()=>{
    if (this.currentEmployer && this.previousEmployers && this.previousEmployers.length && this.additionalIncome ) {
      this.setSelectedIndex(3);
    } else if (this.currentEmployer && ((this.previousEmployers && this.previousEmployers.length) || this.additionalIncome)) {
      this.setSelectedIndex(2);
    } else if (this.currentEmployer || ((this.previousEmployers && this.previousEmployers.length) || this.additionalIncome)) {
      this.setSelectedIndex(1);
    } else {
      this.setSelectedIndex(0);
    }
    this.showCaRentVoucherTab=true;
  }

  initializeAdditionalIncome = () => {
    if (!this.additionalIncome) {
      this.additionalIncome = new AdditionalIncome();
    }

    if (this.currentEmployer && this.previousEmployers && this.previousEmployers.length) {
      this.setSelectedIndex(2);
    } else if (this.currentEmployer || (this.previousEmployers && this.previousEmployers.length)) {
      this.setSelectedIndex(1);
    } else {
      this.setSelectedIndex(0);
    }
  }

  onRemoveCurrentEmployer = () => {
    this.currentEmployer = null;

    this.setSelectedIndex(0);
  }

  onRemovePreviousEmployer = index => {
    if (!this.previousEmployers) {
      return;
    }

    if (this.previousEmployers.length === 1) {
      this.previousEmployers = null;

      this.setSelectedIndex(0);
    } else {
      this.previousEmployers = this.previousEmployers.splice(index, 1);
    }
  }

  onRemoveAdditionalIncome = () => {
    this.additionalIncome = null;

    this.setSelectedIndex(0);
  }
  onRemoveCaRentVoucher=()=>{
    this.caVoucherAmount=null;
    this.showCaRentVoucherTab=false;
    this.setSelectedIndex(0);    
  }
  shouldShowTabs = () => this.currentEmployer || (this.previousEmployers && this.previousEmployers.length) || this.additionalIncome || this.showCaRentVoucherTab;

  setSelectedIndex = index => {
    if (this.employerTabs) {
      this.employerTabs.selectedIndex = index;
    }
  }

  updateSplashHTML(res: string) {
    this.splashHTML = res;
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollIntoView(false);
    } catch (err) { console.log('error: ' + err); }
  }

  checkEmploymentHistory() {
    this.disableSubmitBtn = true;
    let diffDays = 0;

    let endDate = null;
    let startDate = null;

    if (this.currentEmployer) {
      endDate = this.currentEmployer.EndDate ? new Date(this.currentEmployer.EndDate) : new Date();
      startDate = this.currentEmployer.StartDate ? new Date(this.currentEmployer.StartDate) : null;
    }

    if (this.previousEmployers && this.previousEmployers.length) {
      if (!endDate) {
        const latestPreviousEmployerEndDate = Math.max(...this.previousEmployers.map(employer => employer.EndDate ? new Date(employer.EndDate).getTime() : 0));

        if (latestPreviousEmployerEndDate) {
          endDate = new Date(latestPreviousEmployerEndDate);
        }
      }

      let earliestPreviousEmployerStartDate = Math.min(...this.previousEmployers.map(employer => employer.StartDate ? new Date(employer.StartDate).getTime() : Number.MAX_VALUE));

      if (earliestPreviousEmployerStartDate !== Number.MAX_VALUE) {
        startDate = startDate ? new Date(Math.min(startDate.getTime(), earliestPreviousEmployerStartDate)) : new Date(earliestPreviousEmployerStartDate);
      }
    }

    if (!endDate || !startDate) {
      this.analyticsService.track(
        'HRA Application',
        'Employment Information',
        'Two year eployment history required prompt - no history',
        'The user provided no start or end date',
        '',
        this.additionalAnalyticsDetails());
      this.twoYears();

      return;
    }

    const timeDiff = Math.abs(startDate.getTime() - endDate.getTime());
    diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if ((diffDays / 365) < 2) {
      this.analyticsService.track(
        'HRA Application',
        'Employment Information',
        'Two year eployment history required prompt - not enough history',
        'The user did not provide 2 years of employment history',
        '',
        this.additionalAnalyticsDetails());
      this.twoYears();
    } else {
      this.onSubmit();
    }
  }

  twoYears() {
    this.disableSubmitBtn = false;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "300px";

    let dialogRef = this.dialog.open(TwoYearsEmpDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      this.analyticsService.track(
        'HRA Application',
        'Employment Information',
        'Two year eployment history required prompt - result',
        'User selected ' + result,
        '',
        this.additionalAnalyticsDetails());
      if (result == "no") {
        this.onSubmit();
      }
    });
  }

  cancelEdit() {
    localStorage.removeItem('AddAdditionalApplicantKey');
    localStorage.removeItem('AddAdditionalApplicantName');
    this.analyticsService.track(
      'HRA Application',
      'Employment Information',
      'Stop',
      'Cancelling edit',
      '/application/applicants',
      this.additionalAnalyticsDetails());
    this.router.navigate(['/application/applicants']);
  }

  onSubmit() {
    const allEmployers = [];

    if (this.currentEmployer) {
      allEmployers.push(this.currentEmployer);
    }

    if (this.previousEmployers && this.previousEmployers.length) {
      allEmployers.push(...this.previousEmployers);
    }

    if (allEmployers.length) {
      for (const emp of allEmployers) {
        emp.Phone = emp.PhoneNumber.format();
        emp.SupervisorPhone = emp.SupervisorPhoneNumber.format();
        let stringNumber = String(emp.MonthlyPay);
        stringNumber = stringNumber.replace(/[^\d.]/g, '');
        emp.MonthlyPay = Number(stringNumber);
      }
    }

    let addIncome=this.additionalIncome ?? new AdditionalIncome();
    addIncome.CaRentVoucher=this.caVoucherAmount;

    this.employmentService.updateEmploymentInformation(this.RentalApplicantKey, this.RentalApplicationKey, this.CompletedByOther, allEmployers, addIncome)
      .subscribe(res => this.onUpdateSuccess(res), res =>{
        this.disableSubmitBtn = false;
        this.errorMessage = this.applicationService.handleError(res)
      } );
  }

  uploadFiles(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      var index;
      const formData: FormData = new FormData();
      for (index = 0; index < fileList.length; index++) {
        const file: File = fileList[index];
        formData.append('uploadFile' + index, file, file.name);
      }
      this.applicationService.uploadApplicantProofOfIncome(formData, this.AddAdditionalApplicantKey)
        .subscribe(res => this.onFileUploadSuccess(), err => this.errorMessage = this.applicationService.handleError(err));
    }
  }

  onFileUploadSuccess() {
    this.errorService.showMessage("Proof of Income uploaded successfully.");
  }

  onUpdateSuccess(employments: Employer[]) {
    this.analyticsService.track(
      'HRA Application',
      'Employment Information',
      'Stop',
      'Sending to documents',
      '/application/documents',
      this.additionalAnalyticsDetails());
    if(!this.navigateToVerifast) {
      this.router.navigate(['/application/documents'], { fragment: 'documents' });
    } else {
      this.router.navigate(['/application/verifast'], { fragment: 'verifast' });
    }
  }

  onGetEmploymentSuccess(income: IncomeInfo) {

    let AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');
    this.navigateToVerifast = income.verifastEnabled;
    localStorage.setItem('verifastEnabled', this.navigateToVerifast.toString());
    
    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.CompletedByOther = true;
    }
    else {
      this.CompletedByOther = false;
    }

    for (const emp of income.employments) {
      emp.StartDate = new Date(emp.StartDate);

      if (emp.EndDate != null) {
        emp.EndDate = new Date(emp.EndDate);
      }

      if (emp.Phone) {
        const phoneTemp = emp.Phone.replace(/[^A-Z0-9]/ig, "");
        emp.PhoneNumber = new TelephoneNumber(phoneTemp.substr(0, 3), phoneTemp.substr(3, 3), phoneTemp.substr(6, 4));
      }

      if (emp.SupervisorPhone) {
        const supervisorPhoneTemp = emp.SupervisorPhone.replace(/[^A-Z0-9]/ig, "");
        emp.SupervisorPhoneNumber = new TelephoneNumber(supervisorPhoneTemp.substr(0, 3), supervisorPhoneTemp.substr(3, 3), supervisorPhoneTemp.substr(6, 4));
      }
    }

    if (income && income.employments && income.employments.length) {
      this.currentEmployer = income.employments.find(employer => employer.IsCurrnet) || null;
      this.previousEmployers = income.employments.filter(employer => !employer.IsCurrnet) || null;
    } else {
      this.currentEmployer = null
      this.previousEmployers = null;
    }

    if (income.additionalIncome && (income.additionalIncome.AdditionalIncomeAmount || income.additionalIncome.AdditionalIncomeSource)) {
      this.additionalIncome = income.additionalIncome;
    }
    if(income.additionalIncome){
      this.caVoucherAmount=income.additionalIncome.CaRentVoucher;
      this.showCaRentVoucherTab=this.caVoucherAmount!=null;
    }
  }

  onGetIndustriesSuccess(industries: Industry[]) {
    this.industries = [];
    for (const industry of industries) {
      this.industries.push({ label: industry.Title, value: industry.RentalIndustryKey });
    }
  }

  getEmploymentStatus(statuses: EmploymentStatus[]) {
    this.employmentStatus = [];
    for (const status of statuses) {
      this.employmentStatus.push({ label: status.Title, value: status.EmploymentStatusKey });
    }
  }

  initAutoCompleteSettings(data: any, initialValue: any) {
    this.autoCompleteSettings.name = data;
    this.autoCompleteSettings.id = data;
    this.autoCompleteSettings.inputString = initialValue;

    return this.autoCompleteSettings;
  }

  // Do Not Delete.  ngFor will break on add remove without.
  listTrack(o) {
    return o;
  }
}